module.exports = __webpack_public_path__ + "img/title.1142d2f9.webp";